import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login }            = useAuth();
  const navigate    = useNavigate();
  const location    = useLocation();
  const pendingUser = JSON.parse(localStorage.getItem('gpf_pending_user') || 'null');
  const isWelcome   = new URLSearchParams(location.search).get('welcome') === '1';
  const pending     = pendingUser;
  const [username, setUsername] = useState(pendingUser?.username || '');
  const [password, setPassword] = useState('');
  const [error, setError]    = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      localStorage.removeItem('gpf_pending_user');
      navigate('/dashboard');
    } catch (err) {
      setError('Invalid username or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {isWelcome && pending && (
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8, padding: '12px 16px', marginBottom: 20, textAlign: 'center' }}>
            <p style={{ color: '#16a34a', fontWeight: 700, fontSize: 15, margin: 0 }}>🎉 Account created successfully!</p>
            <p style={{ color: '#64748b', fontSize: 13, margin: '4px 0 0' }}>Welcome, {pending.name}! Please log in to access your dashboard.</p>
          </div>
        )}

        {/* Logo */}
        <div style={styles.logoRow}>
          <span style={styles.logoG}>G</span>
          <span style={styles.logoRest}>oProject</span>
          <span style={styles.logoFlow}>Flow</span>
        </div>
        <p style={styles.tagline}>Project Management, Simplified.</p>

        {/* Form */}
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Username</label>
            <input
              style={styles.input}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              required
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={styles.footer}>
          Forgot your password?{' '}
          <Link to="/forgot-password" style={styles.link}>Reset it here</Link>
        </p>

        <div style={styles.divider} />

        <p style={styles.footer}>
          Don't have an account?{' '}
          <a href="https://goprojectflow.com/#signup" style={{ ...styles.link, fontWeight: 700 }}>
            Sign up free →
          </a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: '100vh',
    background: '#f0f4f8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: '#ffffff',
    borderRadius: '12px',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  },
  logoRow: {
    fontSize: '28px',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: '8px',
  },
  logoG: {
    color: '#2563eb',
  },
  logoRest: {
    color: '#1e293b',
  },
  logoFlow: {
    color: '#f97316',
  },
  tagline: {
    textAlign: 'center',
    color: '#64748b',
    fontSize: '14px',
    marginBottom: '32px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
  },
  input: {
    padding: '10px 14px',
    borderRadius: '8px',
    border: '1px solid #d1d5db',
    fontSize: '14px',
    outline: 'none',
    transition: 'border 0.2s',
  },
  error: {
    color: '#ef4444',
    fontSize: '13px',
    textAlign: 'center',
    margin: '0',
  },
  button: {
    padding: '12px',
    background: '#2563eb',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '4px',
  },
  footer: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#64748b',
    marginTop: '24px',
  },
  divider: { borderTop: '1px solid #e2e8f0', margin: '16px 0' },
  link: {
    color: '#2563eb',
    textDecoration: 'none',
  },
};